import { toRefs, computed } from 'vue';

//
var script = {
  props: {
    id: {
      type: String,
      required: true
    },
    options: Object
  },
  setup(props) {
    const {
      options
    } = toRefs(props);
    const height = computed(() => {
      switch (options.value.id) {
        case 'soundcloud_track':
          return '166';
        case 'soundcloud_sets':
          return '450';
      }
      return null;
    });
    return {
      height
    };
  }
};
export { script as default };